module.exports = __webpack_public_path__ + "static/media/umbrella-beach.8154510e.svg";